import {Card, CardContent} from "@mui/material";
import Grid from "@mui/material/Grid";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import React from "react";
import {VesselCall} from "~/queries";


export type VoyageCardProps = {
    voyage: VesselCall["departure"] | VesselCall["arrival"]
}


export const VoyageCard = (props: VoyageCardProps) => {
    const {voyage} = props;
    return (
        <Card>
            <CardContent>
                <Grid container direction="column" rowSpacing="8px" wrap="nowrap">
                    <Grid item>
                        <TypographyWithLabel label="Вид">
                            {voyage.type || <>&ndash;</>}
                        </TypographyWithLabel>
                    </Grid>
                    <Grid item>
                        <TypographyWithLabel label="Номер рейса">
                            {voyage.voyage || <>&ndash;</>}
                        </TypographyWithLabel>
                    </Grid>
                    <Grid item>
                        <TypographyWithLabel label="Линия" noWrap={false}>
                            {voyage.line || <>&ndash;</>}
                        </TypographyWithLabel>
                    </Grid>
                    <Grid item>
                        <TypographyWithLabel label="Порт" noWrap={false}>
                            {[voyage.port?.name, voyage.port?.code].filter(Boolean).join(" / ") || <>&ndash;</>}
                        </TypographyWithLabel>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}